// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__vtbhP","faq":"FAQ_faq__2Hn9Y"};